import _jsx from "@babel/runtime/helpers/jsx";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { memo, useState, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { getBenefits, getMoreInfo, getMenu } from 'utils';
import DropdownButton from 'components/DropdownButton';
import CardItemMoreInfo from 'components/CardItemMoreInfo';
import Hint from 'components/Hint';
import ProductActions from 'components/ProductActions';
import { ProductsInfo, ProductTitle, ProductHead, ProductClientTypes, ProductClientType, ProductMainInfo, ProductMainInfoBlock, ProductMainInfoBlockTitle, ProductMainInfoBlockTitleText, ProductMainInfoBlockText, ProductMainInfoBenefitsBlock, ProductMainInfoBenefit, MoreInfoFooterWrapper, MoreInfoButtonWrapper } from './styles';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx2 } from "react/jsx-runtime";

function BankCardItem(_ref) {
  var card = _ref.card;

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isShowMoreInfo = _useState2[0],
      setIsShowMoreInfo = _useState2[1];

  var _useState3 = useState(getMenu(formatMessage)),
      _useState4 = _slicedToArray(_useState3, 2),
      menuItems = _useState4[0],
      setMenuItems = _useState4[1];

  var handleShowMoreInfo = useCallback(function () {
    return setIsShowMoreInfo(!isShowMoreInfo);
  }, [isShowMoreInfo]);
  var handleSetMenuItems = useCallback(function (currItem) {
    var newMenu = menuItems.map(function (el) {
      return _objectSpread(_objectSpread({}, el), {}, {
        isActive: el.name === currItem
      });
    });
    setMenuItems(newMenu);
  }, [menuItems]);
  var moreInfo = getMoreInfo(formatMessage);
  var benefits = getBenefits(formatMessage, card);
  return /*#__PURE__*/_jsx(ProductsInfo, {}, void 0, /*#__PURE__*/_jsx(ProductHead, {}, void 0, /*#__PURE__*/_jsx(ProductTitle, {}, void 0, card.productName), /*#__PURE__*/_jsx(ProductClientTypes, {}, void 0, !!card.productClientType.length && card.productClientType.map(function (clientType) {
    return /*#__PURE__*/_jsx(ProductClientType, {}, clientType, formatMessage({
      id: "BankCardItem.productClientType.".concat(clientType.toLowerCase())
    }));
  }))), /*#__PURE__*/_jsx(ProductMainInfo, {}, void 0, moreInfo.map(function (block) {
    return /*#__PURE__*/_jsx2(_Fragment, {
      children: block.name === 'cashDeposit' && !card.proceedsEnrollmentCashboxAvailable ? null : /*#__PURE__*/_jsx(ProductMainInfoBlock, {}, block.name, /*#__PURE__*/_jsx(ProductMainInfoBlockTitle, {}, void 0, /*#__PURE__*/_jsx(ProductMainInfoBlockTitleText, {}, void 0, formatMessage({
        id: "BankCardItem.moreInfoBlock.".concat(block.name)
      })), !!block.hint(card) && /*#__PURE__*/_jsx(Hint, {
        position: "bottom"
      }, void 0, /*#__PURE__*/_jsx("span", {}, void 0, block.hint(card)))), /*#__PURE__*/_jsx(ProductMainInfoBlockText, {}, void 0, block.getValue(card)))
    });
  })), (card == null ? void 0 : card.advantages.length) > 0 && /*#__PURE__*/_jsx(ProductActions, {
    advantages: card.advantages
  }), /*#__PURE__*/_jsx(MoreInfoFooterWrapper, {}, void 0, !!benefits.length && /*#__PURE__*/_jsx(ProductMainInfoBenefitsBlock, {}, void 0, benefits.map(function (benefit) {
    return /*#__PURE__*/_jsx(ProductMainInfoBenefit, {}, benefit, benefit);
  })), /*#__PURE__*/_jsx(MoreInfoButtonWrapper, {}, void 0, /*#__PURE__*/_jsx(DropdownButton, {
    showMoreInfo: isShowMoreInfo,
    handleShowInfo: handleShowMoreInfo
  }, void 0, formatMessage({
    id: 'BankCardItem.moreInfoBlock.moreInfoBtn'
  })))), /*#__PURE__*/_jsx(CardItemMoreInfo, {
    card: card,
    menuItems: menuItems,
    handleSetMenuItems: handleSetMenuItems,
    isShowMoreInfo: isShowMoreInfo
  }));
}

export default /*#__PURE__*/memo(BankCardItem);